import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportServiceLevelPage } from './report-service-level.page';

const routes: Routes = [
  {
    path: '',
    component: ReportServiceLevelPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportServiceLevelPageRoutingModule {}
